import { SystemTrayChatPage, withErrorBoundary } from '@nile/components';
import React from 'react';

const SystemTrayChatWrapper = (props) => {
  const { chat } = props;
  return (
    <div className="timerPopup bshadow br10 full-height">
      <SystemTrayChatPage
        heightClassName="max-height-700 vh95"
        widthClassName="w400"
        roundedBorder
        source="web"
        {...chat}
      />
    </div>
  );
};

export default withErrorBoundary(SystemTrayChatWrapper);
